<template>
  <div class="telegram-login-button">
    <div class="telegram-login-button__divider">
      <span>або</span>
    </div>
    <div ref="container" class="telegram-login-button__widget"></div>
    <p v-if="isRetrying" class="telegram-login-button__hint">Завершуємо привʼязку, зачекайте...</p>
    <p v-else-if="error" class="telegram-login-button__error">{{ error }}</p>
  </div>
</template>

<script>
import { Env } from '@/shared/config/environment';

const RETRY_INTERVAL_MS = 2000;
const MAX_RETRY_ATTEMPTS = 10;

export default {
  data() {
    return {
      error: '',
      isRetrying: false,
    };
  },
  mounted() {
    window.onTelegramAuth = this.handleTelegramAuth;

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', Env.telegram.botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');

    this.$refs.container.appendChild(script);
  },
  beforeDestroy() {
    delete window.onTelegramAuth;
  },
  methods: {
    async handleTelegramAuth(telegramUser) {
      this.error = '';
      this.isRetrying = false;

      await this.attemptLogin(telegramUser, 0);
    },
    async attemptLogin(telegramUser, attempt) {
      try {
        await this.$store.dispatch('LOGIN_WITH_TELEGRAM', telegramUser);
        this.isRetrying = false;
        this.$router.push({ name: 'prime' });
      } catch (e) {
        if (e.response?.status === 404 && attempt < MAX_RETRY_ATTEMPTS) {
          this.isRetrying = true;
          setTimeout(() => this.attemptLogin(telegramUser, attempt + 1), RETRY_INTERVAL_MS);
          return;
        }

        this.isRetrying = false;
        this.error = e.response?.status === 404
          ? 'Telegram не привʼязано до акаунту. Увійдіть звичайним способом і привʼяжіть бота в кабінеті (Ресурси → Мій Telegram-бот).'
          : 'Не вдалося увійти через Telegram.';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.telegram-login-button {
  margin-top: 8px;

  &__divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 16px;
    color: #8e9db7;
    font-family: 'Inter', sans-serif;
    font-size: 14px;

    &::before,
    &::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #dde2e5;
    }

    span {
      margin: 0 12px;
    }
  }

  &__widget {
    display: flex;
    justify-content: center;
  }

  &__error {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #f00;
    text-align: center;
    margin-top: 12px;
  }

  &__hint {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #8e9db7;
    text-align: center;
    margin-top: 12px;
  }
}
</style>
